import createAxios from "./axiosHttpMarconi";

function getValoracion(valoracionId) {
  const axios = createAxios();
  const cliente = JSON.parse(localStorage.getItem("cliente"));
  let urlPath = `cliente/${cliente._id}/valoracion/${valoracionId}`;
  return axios.get(urlPath);
}

export const valoracionService = {
  getValoracion,
};
